import { z } from 'zod';
import { AgentProtocolEnum } from '../enums/agent.js';
import { authDetailsSchema, authSchema } from './auth.js';

export const agentToAgentDataSchema = z.object({
  auth: authSchema,
  wellKnownUri: z.url().or(z.literal('')),
  url: z.url(),
});
export const agentToAgentProtocolSchema = z.object({
  type: z.literal(AgentProtocolEnum.A2A),
  data: agentToAgentDataSchema,
});

export const agentToAgentDetailsDataSchema = z.object({
  auth: authDetailsSchema,
  wellKnownUri: z.url().or(z.literal('')),
  url: z.url(),
});
export const agentToAgentDetailsProtocolSchema = z.object({
  type: z.literal(AgentProtocolEnum.A2A),
  data: agentToAgentDetailsDataSchema,
});

export type AgentToAgentData = z.infer<typeof agentToAgentDataSchema>;
export type Agent2AgentAgentDetails = z.infer<typeof agentToAgentDetailsDataSchema>;

export const mcpToolAgentDataSchema = z.object({
  auth: authSchema,
  toolName: z.string(),
  url: z.string(),
});
export const mcpToolAgentProtocolSchema = z.object({
  type: z.literal(AgentProtocolEnum.MCP),
  data: mcpToolAgentDataSchema,
});
export type McpToolAgentData = z.infer<typeof mcpToolAgentDataSchema>;
export type McpToolAgentDetails = z.infer<typeof mcpToolAgentDetailsDataSchema>;

export const mcpToolAgentDetailsDataSchema = z.object({
  auth: authDetailsSchema,
  toolName: z.string(),
  url: z.string(),
});
export const mcpToolAgentDetailsProtocolSchema = z.object({
  type: z.literal(AgentProtocolEnum.MCP),
  data: mcpToolAgentDetailsDataSchema,
});

export const apiServerAgentDataSchema = z.object({
  url: z.string(),
  auth: authSchema,
  stream: z.boolean().optional(),
});
export const apiServerAgentProtocolSchema = z.object({
  type: z.literal(AgentProtocolEnum.HTTP),
  data: apiServerAgentDataSchema,
});
export type ApiServerAgentData = z.infer<typeof apiServerAgentDataSchema>;
export type ApiServerAgentDetails = z.infer<typeof apiServerAgentDetailsDataSchema>;

export const apiServerAgentDetailsDataSchema = z.object({
  auth: authDetailsSchema,
  url: z.string(),
  stream: z.boolean().optional(),
});

export const apiServerAgentDetailsProtocolSchema = z.object({
  type: z.literal(AgentProtocolEnum.HTTP),
  data: apiServerAgentDetailsDataSchema,
});

export const internalProtocolSchema = z.object({
  type: z.literal(AgentProtocolEnum.Internal),
  data: z.object({}),
});

export const agentProtocolDataSchema = z.discriminatedUnion('type', [
  agentToAgentProtocolSchema,
  mcpToolAgentProtocolSchema,
  apiServerAgentProtocolSchema,
  internalProtocolSchema,
]);
export type AgentProtocolData = z.infer<typeof agentProtocolDataSchema>;

export const agentProtocolDetailsDataSchema = z.discriminatedUnion('type', [
  agentToAgentDetailsProtocolSchema,
  mcpToolAgentDetailsProtocolSchema,
  apiServerAgentDetailsProtocolSchema,
  internalProtocolSchema,
]);
export type AgentProtocolDetails = z.infer<typeof agentProtocolDetailsDataSchema>;
